import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { MediaProvider } from "@/context/MediaContext";
import { ProductsProvider } from "@/context/ProductsContext";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ConciergeChat from "@/components/ConciergeChat";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import CollectionPage from "@/pages/CollectionPage";
import Collections from "@/pages/Collections";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import PolicyPage from "@/pages/PolicyPage";
import Checkout from "@/pages/Checkout";
import TrackOrder from "@/pages/TrackOrder";
import ProductPage from "@/pages/ProductPage";
import Experience from "@/pages/Experience";
import WordOfMouth from "@/pages/WordOfMouth";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App noise">
      <MediaProvider>
      <ProductsProvider>
      <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <CartDrawer />
        <WhatsAppButton />
        <ConciergeChat />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/collections/:slug" element={<CollectionPage />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/word-of-mouth" element={<WordOfMouth />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/policies/:slug" element={<PolicyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      </CartProvider>
      </ProductsProvider>
      </MediaProvider>
      <Toaster position="top-center" toastOptions={{ style: { background: "#F7F3EE", color: "#111111", border: "1px solid #BA8D53", borderRadius: 0, fontFamily: "'Outfit', sans-serif" } }} />
    </div>
  );
}

export default App;
